<template>
  <main class="app-content" v-if="agency && campaign">
    <aside class="fixed-sidebar">
      <side-bar :agency="agency"></side-bar>
    </aside>
    <div class="project-layout app-content">
      <template>
        <header class="project-header">
          <h1>{{ agency.displayName }}</h1>
        </header>
      </template>
      <div class="container-fluid dashboard">
        <div class="row order-media" id="campaign-container">
          <div class="col-md-12" v-if="campaign">
            <br />
            <div class="space-between">
              <button
                type="button"
                @click="goBackRoute"
                class="btn btn-quaternary"
              >
                {{ backButtonText }}
              </button>
              <div class="c__btn--container d-md-block d-none">
                <button
                  type="button"
                  @click="goToCreative"
                  class="btn btn-quaternary mr-10"
                  v-if="Object.entries(campaign.officeCreative).length > 0"
                >
                  Creative
                </button>
                <button
                  type="button"
                  class="btn btn-quaternary"
                  @click="downloadPdfReport"
                >
                  Export Campaign Report
                </button>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-12" v-if="campaign">
                <h2 style="text-transform: capitalize">
                  {{ campaign.type }} campaign
                </h2>
              </div>
            </div>
            <br />
            <template>
              <div class="row">
                <div class="col-lg-3 col-xs-4" v-if="propertyImages.length > 0">
                  <div
                    class="img-wrapper"
                    v-for="(index, image) in propertyImages"
                    :key="index"
                  >
                    <div class="c__card--image--container c__slider--card">
                      <img :src="image" :data-src="image" />
                    </div>
                  </div>
                </div>
                <div class="col-md-9 col-xs-8">
                  <div class="heading capitalized-text" v-if="campaign.type">
                    <p><b>Campaign Type: </b>{{ campaign.type }}</p>
                  </div>
                  <div class="heading" v-if="campaign.startDate">
                    <p>
                      <b>Campaign Start Date: </b
                      >{{ campaign.startDate | formatDate('DD MMM YYYY') }} /
                      {{ campaign.duration }} days
                    </p>
                  </div>
                  <div
                    class="heading"
                    v-if="campaign.package && $isAllowed('viewPrices')"
                  >
                    <p>
                      <b>Price: </b>{{ campaign.retailPrice | formatCurrency }}
                      <template v-if="hasGst"
                        >incl. GST</template
                      >
                      <template v-else
                        >excl. GST</template
                      >
                    </p>
                  </div>
                  <div class="heading" v-if="stats['budgetSpent']">
                    <p><b>Budget Spent: </b>{{ stats['budgetSpent'] }}%</p>
                  </div>
                  <div class="heading" v-if="campaign.postcode">
                    <p><b>Postcodes: </b>{{ campaign.postcode }}</p>
                  </div>
                  <div class="heading" v-if="campaign.destinationUrl">
                    <p>
                      <b>Destination URL: </b>
                      <a :href="campaign.destinationUrl" target="_blank">{{
                        campaign.destinationUrl
                      }}</a>
                    </p>
                  </div>
                  <div class="heading" v-if="hasAdminAccess">
                    <p>
                      <b>Logs: </b>
                      <a @click="goToSignifiLogs" href="#">Signifi Logs</a>
                    </p>
                  </div>
                  <div class="heading" v-if="audienceName">
                    <p>
                      <b>Audience: </b>
                      {{ audienceName }}
                    </p>
                  </div>
                </div>
              </div>
              <br />
            </template>

            <awareness-stats-section
              :adImpressions="this.adImpressions"
            ></awareness-stats-section>

            <interest-and-engagement-stats-section
              :adClicks="adClicks"
              :ctr="ctr"
              :socialAdEngagement="socialEngagement"
            ></interest-and-engagement-stats-section>

            <enquiry-section
              :enquiryViaSocial="enquiryViaSocial"
              :enquiryViaForm="enquiryViaForm"
              :enquiryViaPhone="enquiryViaPhone"
              :enquiryViaEmail="enquiryViaEmail"
            ></enquiry-section>

            <div id="creative"></div>
          </div>
        </div>
        <div
          class="creative col-12 mt-5"
          ref="creative"
          v-if="Object.entries(campaign.officeCreative).length > 0"
        >
          <h2>Office Creative</h2>
          <div class="row">
            <template v-for="(creative, index) in campaign.officeCreative">
              <div class="col-12" :key="index">
                <h3>{{ index }}</h3>
                <iframe
                  :width="index.substring(0, 3)"
                  frameborder="0"
                  :height="index.substring(index.length - 3, index.length)"
                  :src="creative"
                ></iframe>
              </div>
            </template>
          </div>
        </div>
        <div
          class="creative col-12 mt-5"
          ref="creative"
          v-if="
            campaign &&
              campaign.signifiPreviewFacebookIframe &&
              campaign.status != 'Finished'
          "
        >
          <div class="row">
            <div class="col-12">
              <h3>Facebook</h3>
              <div v-html="campaign.signifiPreviewFacebookIframe"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import SideBar from '../SideBar';
import AgencyService from '../../../services/agencies';
import CampaignPerimeters from '../../../configs/Perimeters/campaigns';
import CampaignServices from '../../../services/campaigns';
import Navigation from '../../../configs/Perimeters/navigation';
import ClientServices from '../../../services/clients';
import CampaignStatServiceV2 from '../../../services/V2/CampaignStatServiceV2';
import AwarenessStatsSection from '../../CampaignStats/AwarenessStatsSection';
import InterestAndEngagementStatsSection from '../../CampaignStats/InterestAndEngagementStatsSection';
import EnquirySection from '../../CampaignStats/EnquirySection';
import CampaignServiceV2 from '../../../services/V2/CampaignServiceV2';
import {format} from 'date-fns';
import AudienceServiceV2 from '../../../services/V2/AudienceServiceV2';

export default {
  perimeters: [CampaignPerimeters],
  components: {
    SideBar,
    EnquirySection,
    InterestAndEngagementStatsSection,
    AwarenessStatsSection,
  },
  computed: {
    backButtonText() {
      if (this.prevRouteName == 'ordersList') {
        return 'BACK TO ORDERS';
      } else if (this.prevRouteName == 'AgencyOrders') {
        return 'BACK TO CAMPAIGNS';
      } else {
        return 'GO TO CAMPAIGNS';
      }
    },
    adImpressions() {
      return this.stats.adImpressions
        ? formatNumber(this.stats.adImpressions)
        : null;
    },
    adClicks() {
      return this.stats.adClicks ? formatNumber(this.stats.adClicks) : null;
    },
    ctr() {
      return this.stats.socialCtr ? `${this.stats.socialCtr}%` : null;
    },
    socialEngagement() {
      return this.stats.socialEngagement
        ? formatNumber(this.stats.socialEngagement)
        : null;
    },
    enquiryViaSocial() {
      return this.stats.enquiryViaSocial
        ? formatNumber(this.stats.enquiryViaSocial)
        : null;
    },
    enquiryViaForm() {
      return this.stats.enquiryViaForm
        ? formatNumber(this.stats.enquiryViaForm)
        : null;
    },
    enquiryViaPhone() {
      return this.stats.enquiryViaPhone
        ? formatNumber(this.stats.enquiryViaPhone)
        : null;
    },
    enquiryViaEmail() {
      return this.stats.enquiryViaEmail
        ? formatNumber(this.stats.enquiryViaEmail)
        : null;
    },
    hasGst() {
      return this.agency ? this.agency.includeGst : true;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRouteName = from.name;
    });
  },
  data() {
    return {
      chartOptions: {
        height: 350,
        colors: ['#13a3eb'],
        seriesType: 'bars',
        bar: {groupWidth: 20},
        legend: {position: 'bottom'},
        series: {
          0: {
            bar: {groupWidth: '20%'},
          },
        },
      },
      googleChart: '',
      formState: {},
      showDescription: false,
      campaign: null,
      agency: null,
      campaigns: [],
      stats: {},
      prevRouteName: null,
      hasAdminAccess: false,
      propertyImages: [],
      displayConfig: {},
      audienceName: null,
    };
  },
  methods: {
    getPropertyImages() {
      if (
        this.campaign &&
        this.campaign.propertyImages &&
        this.campaign.propertyImages.length > 0
      ) {
        this.campaign.propertyImages.forEach((image) => {
          this.propertyImages.push(
            process.env.VUE_APP_CDN_URL + image.location
          );
        });
      }
    },
    goToCreative() {
      this.$nextTick(() => {
        document.getElementById('creative').scrollIntoView();
      });
    },
    async downloadPdfReport() {
      const response = await CampaignServiceV2.downloadPdfReport(
        this.campaign.id,
        {
          responseType: 'blob',
        }
      );
      const filename = response.headers['acquire-filename'];

      const pdfBlob = new Blob([response.data], {type: 'application/pdf'});

      const downloadUrl = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename; // Set the file name
      document.body.appendChild(link);
      link.click();

      // Clean up the URL object and remove the link element
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    },
    goBackRoute() {
      console.log(this.prevRouteName);
      if (
        this.prevRouteName == 'ordersList' ||
        this.prevRouteName == 'AgencyOrders'
      ) {
        this.$router.go(-1);
      } else {
        this.$router.push({name: 'AgencyOrders'});
      }
    },
    checkUserPermissions() {
      const isAdmin = Navigation.isSuperAdmin() || Navigation.isAdmin();
      this.hasAdminAccess = isAdmin;
    },
    goToSignifiLogs() {
      if (this.campaign) {
        const routeData = this.$router.resolve({
          name: 'SignifiLogs',
          params: {campaignId: this.campaign.id},
        });
        window.open(routeData.href, '_blank');
      }
    },
  },
  mounted() {
    CampaignServices.getCampaign(this.$route.params.campaignId, 'agency').then(
      (result) => {
        this.campaign = result;

        AgencyService.getAgency(
          this.$route.params.agency,
          'address,client,permissions,ordersReport'
        ).then((agency) => {
          this.agency = agency;

          ClientServices.getClientDisplayConfig(this.agency.client.id).then(
            (displayConfig) => {
              this.displayConfig = displayConfig;
            }
          );
        });

        if (this.campaign.audienceId) {
          AudienceServiceV2.getAudience(this.campaign.audienceId).then(
            (response) => {
              if (response && response.data && response.data.data) {
                this.audienceName = response.data.data.name;
              }
            }
          );
        }

        this.getPropertyImages();
        this.checkUserPermissions();
      }
    );

    CampaignStatServiceV2.getCampaignStats(this.$route.params.campaignId).then(
      (r) => {
        this.stats = r.data.data;
      }
    );
  },
};
</script>
